/**
 * 資料ダウンロードフォーム（SPIRAL 連携）用スクリプト
 *
 * 送信ボタンを押した時点で必須項目を検証し、未入力があれば送信を止めて赤字メッセージを表示する。
 * 検証を通れば何もせず、ブラウザ標準の POST（form の action = SPIRAL）へそのまま流す。
 *
 * ※ 送信ボタンが name="submit"（SPIRAL の見本に準拠）のため、form.submit() は使えない
 *    （submit プロパティがボタン要素で上書きされる）。preventDefault() する／しないだけで制御している。
 *
 * enqueue: app/common.php で is_page('download') のときのみ読み込む
 */
(function () {
  'use strict';

  var ERROR_CLASS = 'p-download__error';
  var INVALID_CLASS = 'is-error';
  var MAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  document.addEventListener('DOMContentLoaded', function () {
    var form = document.querySelector('.js-downloadForm');
    if (!form) {
      return;
    }

    // 検証対象は data-label を持つ入力欄だけ（SPIRAL 制御用の hidden は対象外）
    var fields = Array.prototype.slice.call(form.querySelectorAll('[data-label]'));
    if (!fields.length) {
      return;
    }

    // エラーメッセージを差し込む親要素
    function errorHolder(field) {
      return field.closest('.p-download__row, .p-download__agree') || field.parentNode;
    }

    // 検証結果のメッセージを返す（問題なければ空文字）
    function validate(field) {
      var label = field.getAttribute('data-label') || '';
      var required = field.hasAttribute('required');

      if (field.type === 'checkbox') {
        return required && !field.checked ? label + 'に同意してください。' : '';
      }

      var value = field.value.trim();
      if (required && !value) {
        return label + 'を入力してください。';
      }
      if (field.type === 'email' && value && !MAIL_PATTERN.test(value)) {
        return 'メールアドレスの形式が正しくありません。';
      }
      return '';
    }

    function clearError(field) {
      field.classList.remove(INVALID_CLASS);
      var message = errorHolder(field).querySelector('.' + ERROR_CLASS);
      if (message) {
        message.parentNode.removeChild(message);
      }
    }

    function showError(field, text) {
      field.classList.add(INVALID_CLASS);
      var holder = errorHolder(field);
      var message = holder.querySelector('.' + ERROR_CLASS);
      if (!message) {
        message = document.createElement('p');
        message.className = ERROR_CLASS;
        holder.appendChild(message);
      }
      message.textContent = text;
    }

    // 一度エラーになった項目だけ、入力し直した時点で再検証する（初回入力中は何も出さない）
    fields.forEach(function (field) {
      field.addEventListener(field.type === 'checkbox' ? 'change' : 'input', function () {
        if (!field.classList.contains(INVALID_CLASS)) {
          return;
        }
        var text = validate(field);
        if (text) {
          showError(field, text);
        } else {
          clearError(field);
        }
      });
    });

    // SPIRAL への送信は画面遷移を伴うため、応答待ちの間の連打を防ぐ
    var sending = false;
    window.addEventListener('pageshow', function () {
      sending = false;
    });

    form.addEventListener('submit', function (event) {
      if (sending) {
        event.preventDefault();
        return;
      }

      var firstInvalid = null;
      fields.forEach(function (field) {
        var text = validate(field);
        if (text) {
          showError(field, text);
          if (!firstInvalid) {
            firstInvalid = field;
          }
        } else {
          clearError(field);
        }
      });

      if (firstInvalid) {
        event.preventDefault();
        firstInvalid.focus();
        return;
      }

      sending = true;
    });
  });
})();
